import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/ui/Hero';
import Features from '../components/ui/Features';
import Stats from '../components/ui/Stats';
import SEOHelmet from '../components/SEOHelmet';

const Home: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "12and22",
    "url": "https://12and22.com",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://12and22.com/domains?search={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <div className="min-h-screen">
      <SEOHelmet
        title="12and22 - Premium Web Hosting, Domains & VPS Solutions | Reliable Hosting Services"
        description="Get reliable web hosting, domain registration, VPS servers, and business email solutions at 12and22. 99.9% uptime guarantee, 24/7 support, and competitive pricing. Start your online journey today!"
        keywords="web hosting, domain registration, VPS hosting, business email, cloud hosting, dedicated servers, SSL certificates, website builder, 12and22"
        canonicalUrl="https://12and22.com"
        structuredData={structuredData}
      />
      <Hero />
      <Stats />
      <Features />
      
      {/* CTA Section */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-white via-gray-50 to-gray-100 border border-gray-200 rounded-2xl p-12 text-center shadow-xl relative overflow-hidden">
            {/* Glossy overlay */}
            <div className="absolute inset-0 bg-gradient-to-br from-white/30 via-white/10 to-transparent rounded-2xl"></div>
            <div className="relative z-10">
            <div className="inline-flex items-center px-4 py-2 mb-6 bg-gradient-to-r from-yellow-50 to-orange-50 border border-yellow-200 rounded-full">
              <span className="w-2 h-2 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full mr-3"></span>
              <span className="text-sm font-semibold text-gray-700">Get Started Today</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
              Ready to Get Started?
            </h2>
            
            <p className="text-xl text-gray-600 mb-10 max-w-3xl mx-auto">
              Join thousands of satisfied customers who trust 12and22 for their hosting, VPS, and business email needs.
              Start your journey today with our reliable and scalable solutions.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link
                to="/hosting"
                className="bg-gradient-to-br from-primary-navy via-primary-800 to-primary-900 text-white px-8 py-4 rounded-lg font-bold text-lg hover:from-primary-800 hover:via-primary-900 hover:to-primary-navy transition-all duration-200 shadow-lg relative overflow-hidden group"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-white/20 via-transparent to-transparent group-hover:from-white/30 transition-all duration-200 rounded-lg"></div>
                <span className="relative z-10">View Our Services</span>
              </Link>
              <Link
                to="/contact"
                className="border-2 border-orange-400 text-orange-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gradient-to-br hover:from-orange-400 hover:via-yellow-500 hover:to-orange-600 hover:text-white hover:border-transparent transition-all duration-200 shadow-lg relative overflow-hidden group"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-transparent group-hover:from-white/20 transition-all duration-200 rounded-lg"></div>
                <span className="relative z-10">Contact Sales</span>
              </Link>
            </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;